import { createFileRoute } from '@tanstack/react-router';
import { PageHeader } from '@/components/ui/PageHeader';
import { StaffOnly } from '@/features/admin-content/StaffOnly';
import { useCurrentUser } from '@/features/admin-content/use-current-user';
import { FeedbackList } from '@/features/support/FeedbackList';

export const Route = createFileRoute('/admin/feedback/')({
  component: AdminFeedbackPage,
});

function AdminFeedbackPage() {
  const me = useCurrentUser();
  if (me.data && !me.data.staff?.studentSupport) {
    return (
      <StaffOnly
        title="Student support is off for you"
        description="Ask an admin to switch it on and give you students."
      />
    );
  }
  return (
    <div className="grid gap-6">
      <PageHeader
        eyebrow="Staff portal"
        title="Feedback to give"
        description="Writing and Speaking results from your students. Open one to read it next to the AI marking and add your own."
      />
      <FeedbackList />
    </div>
  );
}
